/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const cloud_rain_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cloud_rain_medium_svg__a)">
      <path
        fill="#000"
        d="m5.066 7.087.14.737-.14-.737Zm13.872 1.925-.742-.11a.75.75 0 0 0 .8.858l-.058-.748ZM8.126 8.32a.75.75 0 1 0 .748-1.3l-.748 1.3ZM6.214 20.03a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm-2.744.624a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm7.244-.624a.75.75 0 1 0-1.06-1.06l1.06 1.06ZM6.47 22.154a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm8.744-2.124a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm-2.744.624a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm7.244-.624a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm-4.244 2.124a.75.75 0 1 0 1.06 1.06l-1.06-1.06ZM6 16.25A4.25 4.25 0 0 1 1.75 12H.25A5.75 5.75 0 0 0 6 17.75v-1.5ZM22.5 13a3.25 3.25 0 0 1-3.25 3.25v1.5A4.75 4.75 0 0 0 24 13h-1.5ZM6 17.75h13.25v-1.5H6v1.5ZM1.75 12a4.252 4.252 0 0 1 3.456-4.176L4.927 6.35A5.752 5.752 0 0 0 .25 12h1.5Zm4.062-4.828C6.195 3.822 9.184 1.75 12 1.75V.25c-3.456 0-7.195 2.528-7.679 6.752l1.49.17ZM12 1.75c4.143 0 6.7 3.737 6.196 7.153l1.484.218C20.3 4.913 17.17.25 12 .25v1.5Zm6.995 8.01C20.85 9.617 22.5 11.137 22.5 13H24c0-2.741-2.399-4.946-5.12-4.736l.115 1.496ZM5.205 7.824a4.301 4.301 0 0 1 2.921.496l.748-1.3a5.801 5.801 0 0 0-3.947-.67l.279 1.474Zm-.05 11.146L3.47 20.654l1.06 1.06 1.684-1.684-1.06-1.06Zm4.5 0L6.47 22.154l1.06 1.06 3.184-3.184-1.06-1.06Zm4.5 0-1.684 1.684 1.06 1.06 1.684-1.684-1.06-1.06Zm4.5 0-3.184 3.184 1.06 1.06 3.184-3.184-1.06-1.06Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_rain_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_rain_medium
